// extracted by mini-css-extract-plugin
export default {"pointer":"banner_pointer__Ehm1z","btn_hover_circle":"banner_btn_hover_circle__xs9B0"};